export const text = {
  header: "CERTIFICATIONS/SPECIFICATIONS",
  etl: "ETL Intertek Logo",
  ul: "UL Logo",
  ite: "ITE Logo",
  dlc: "DLC Listed Logo",
};
